import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Image } from 'semantic-ui-react';

import auth from '../../utils/auth';
import loginSchema from '../../schemas/login';
import loginShape from '../../shapes/loginShape';
import SnukForm from '../reusable/SnukForm';
import snukLogin from '../../assets/snukLogin.png';

class Login extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loginState: PropTypes.shape({
      isError: PropTypes.bool.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
    submitLogin: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    auth.logout();
  }

  render() {
    const {
      t, loginState, submitLogin, resetPassword,
    } = this.props;
    const { isError, message, isPending } = loginState;
    return (
      <Grid>
        <Grid.Row style={{ paddingTop: '10vh' }}>
          <Grid.Column width="6" />
          <Grid.Column width="4">
            <Image src={snukLogin} size="small" centered />
            <div style={{ paddingTop: '35px' }}>
              <SnukForm
                schema={loginSchema}
                shape={loginShape}
                isPending={isPending}
                btnText={t('common.login')}
                btnStyle="default"
                onSubmitAction={submitLogin}
                externalMessage={{ isError, messages: message.length ? [message] : [] }}
                leftElement={() => <a>{t('usersConfig.forgot?')}</a>}
                leftElementOnClick={(that) => {
                  that.customValidate('email', resetPassword);
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column width="6" />
        </Grid.Row>
      </Grid>
    );
  }
}

export default translate()(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js